export const getFontAwesomeIcon = iconString => {
	// Convert "fab fa-shopify" to ["fab", "shopify"]
	const parts = iconString.split(' ')
	if (parts.length >= 2) {
		return [parts[0], parts[1].replace('fa-', '')]
	}
	return iconString
}
